import {
  editEngagementCampaignDetailsSchema,
  editJobCampaignDetailsSchema
} from './schemas';
import {
  editEngagementCampaignDetailsFields,
  editJobCampaignDetailsFields
} from './fields';

export * from './schemas';

export const editEngagementCampaignDetailsForm = {
  schema: editEngagementCampaignDetailsSchema,
  fields: editEngagementCampaignDetailsFields
};

export const editJobCampaignDetailsForm = {
  schema: editJobCampaignDetailsSchema,
  fields: editJobCampaignDetailsFields
};
